"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var json_stringify_safe_1 = __importDefault(require("json-stringify-safe"));

var ramda_1 = require("ramda");

var yamljs_1 = require("yamljs");

exports.isBrowser = typeof window !== "undefined";

exports.getPixelRatio = function () {
  return exports.isBrowser && window.devicePixelRatio || 1;
}; // tslint:disable-next-line:ban-types


function isFunction(functionToCheck) {
  return functionToCheck && {}.toString.call(functionToCheck) === "[object Function]";
}

exports.isFunction = isFunction;

exports.toYml = function (input) {
  return typeof input !== "object" ? input : ramda_1.compose(function (obj) {
    return yamljs_1.stringify(obj, 10, 2);
  }, JSON.parse, json_stringify_safe_1.default)(input);
};